import { loadAndTrack } from "redux-request-loading";
import { Payload } from "@neworbit/redux-helpers";

import { Dispatch } from "../store";

import { CustomMedicalType, CustomMedicalTypeListModel } from "./models";

import * as actions from "./actiontypes";
import { CustomMedicalTypeApi } from "./customMedicalTypesApi";
import { CustomMedicalTypeFormModel } from "./schema";

export type CustomMedicalTypeAction =
      ({ type: typeof actions.LOAD_CUSTOM_MEDICAL_TYPES_SUCCESS } & Payload<CustomMedicalType[]>)
    | ({ type: typeof actions.CREATE_CUSTOM_MEDICAL_TYPE_SUCCESS } & Payload<CustomMedicalTypeListModel>);

export const createMedicalTypeSuccess = (payload: CustomMedicalTypeListModel): CustomMedicalTypeAction => ({
    payload,
    type: actions.CREATE_CUSTOM_MEDICAL_TYPE_SUCCESS
});

export function createMedicalType(customMedicalType: CustomMedicalTypeFormModel) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.CREATE_CUSTOM_MEDICAL_TYPE, CustomMedicalTypeApi.create(customMedicalType));
        if (result) {
            dispatch(createMedicalTypeSuccess(result));
        }
    };
}

export const loadCustomMedicalTypesSuccess = (payload: CustomMedicalType[]) => ({
    payload,
    type: actions.LOAD_CUSTOM_MEDICAL_TYPES_SUCCESS
});
